import React from 'react';
import { ClockIcon, ListIcon } from 'lucide-react';
type TabType = 'create' | 'manage';
interface CronTabNavigationProps {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
}
export const CronTabNavigation: React.FC<CronTabNavigationProps> = ({
  activeTab,
  setActiveTab
}) => {
  const tabs = [{
    id: 'create',
    label: 'Create Job',
    icon: <ClockIcon size={18} data-id="element-157" />
  }, {
    id: 'manage',
    label: 'Manage Jobs',
    icon: <ListIcon size={18} data-id="element-158" />
  }];
  return <div className="border-b border-gray-200" data-id="element-159">
      <nav className="flex -mb-px space-x-8" data-id="element-160">
        {tabs.map(tab => <button key={tab.id} className={`
              flex items-center py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === tab.id ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `} onClick={() => setActiveTab(tab.id as TabType)} data-id="element-161">
            <span className="mr-2" data-id="element-162">{tab.icon}</span>
            {tab.label}
          </button>)}
      </nav>
    </div>;
};